import "./tablemill";
import { TrendsController } from "./controller/trends";
import { DashboardsController } from "./controller/dashboards_controller";
import { tablemill } from "./tablemill_metal";
import { MatchesController } from "./controller/matches_controller";
import { TrendResearchesController } from "./controller/trend_researches_controller";
import { ComparisonController } from "./controller/comparison";
import { CombinationComparisonsController } from "./controller/combination_comparisons_controller";
import { ReverseMatchesController } from "./controller/reverse_matches_controller";
import { RankingsController } from "./controller/rankings";
import { CookTrendsController } from "./controller/cook_trends_controller";
import { CookMatchesController } from "./controller/cook_matches_controller";
import { CookRankingsController } from "./controller/cook_rankings_controller";
import { EasyResearchesController } from "./controller/easy_researches_controller";
import { ManualsController } from "./controller/manuals_controller";

// Hamburger menu functionality
document.addEventListener('DOMContentLoaded', function () {
  const hamburgerToggle = document.getElementById('hamburger_toggle');
  const body = document.body;

  if (hamburgerToggle) {
    hamburgerToggle.addEventListener('click', function () {
      body.classList.toggle('sidebar-open');
      hamburgerToggle.classList.toggle('active');
    });

    // Close sidebar when clicking on overlay
    document.addEventListener('click', function (e) {
      if (body.classList.contains('sidebar-open') &&
        !hamburgerToggle.contains(e.target as Node) &&
        !document.querySelector('#main_menu')?.contains(e.target as Node)) {
        body.classList.remove('sidebar-open');
        hamburgerToggle.classList.remove('active');
      }
    });
  }
});

new TrendsController();
tablemill.activateControllerFor("dashboards", DashboardsController);
tablemill.activateControllerFor("matches", MatchesController);
tablemill.activateControllerFor("trend_researches", TrendResearchesController);
new ComparisonController();
tablemill.activateControllerFor(
  "combination_comparisons",
  CombinationComparisonsController,
);
tablemill.activateControllerFor("reverse_matches", ReverseMatchesController);
new RankingsController();
tablemill.activateControllerFor("cook_trends", CookTrendsController);
tablemill.activateControllerFor("cook_matches", CookMatchesController);
tablemill.activateControllerFor("cook_rankings", CookRankingsController);
tablemill.activateControllerFor("easy_researches", EasyResearchesController);
tablemill.activateControllerFor("manuals/video_lectures", ManualsController);
